import { render } from "./PixelCount.vue?vue&type=template&id=1cd3a566"
import script from "./PixelCount.vue?vue&type=script&lang=js"
export * from "./PixelCount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__